import { render, staticRenderFns } from "./UsersCopyViews.vue?vue&type=template&id=5552d1ee&scoped=true"
import script from "./UsersCopyViews.vue?vue&type=script&lang=ts"
export * from "./UsersCopyViews.vue?vue&type=script&lang=ts"
import style0 from "./UsersCopyViews.vue?vue&type=style&index=0&id=5552d1ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552d1ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5552d1ee')) {
      api.createRecord('5552d1ee', component.options)
    } else {
      api.reload('5552d1ee', component.options)
    }
    module.hot.accept("./UsersCopyViews.vue?vue&type=template&id=5552d1ee&scoped=true", function () {
      api.rerender('5552d1ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/UsersCopyViews.vue"
export default component.exports